<div class="w-100 h-100">
    <div class="d-flex justify-content-center" style="padding-top: 40px;padding-bottom: 25px;">
        <div class="box pb-3">
            <div class="card-box bg-blue" :class="{ 'active': filterModel.serviceType === null }" @click="filter(null)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{ $t('shared.allEvaluation') }}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{ boxModel.total }}</h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-green" :class="{ 'active': filterModel.serviceType === 1 }" @click="filter(1)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{ $t('shared.senderRegistrationEvaluation') }}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{ boxModel.senderNameRegistration }}</h2>
                    </div>
                </div>
                <div class="card-box-footer text-right">
                    {{ Math.round(boxModel.senderNameRegistrationPercentage) }}%
                </div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-gray" :class="{ 'active': filterModel.serviceType === 2 }" @click="filter(2)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{ $t('shared.contractEvaluation') }}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{ boxModel.contractRequest }}</h2>
                    </div>
                </div>
                <div class="card-box-footer text-right">
                    {{ Math.round(boxModel.contractRequestPercentage) }}%
                </div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-parpol" :class="{ 'active': filterModel.serviceType === 3 }" @click="filter(3)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{ $t('shared.connectivityEvaluation') }}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{ boxModel.connectivityRequest }}</h2>
                    </div>
                </div>
                <div class="card-box-footer text-right">
                    {{ Math.round(boxModel.connectivityRequestPercentage) }}%
                </div>
            </div>
        </div>
    </div>

    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="search()"></i>
                                {{$t('shared.ratingResults')}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control" type="text"
                                    v-model="filterModel.providerName" @input="onProviderInput"
                                    :placeholder="$t('shared.providerName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="processingDateFromMenu" :close-on-content-click="false" :nudge-right="10"
                                    transition="scale-transition" lazy full-width min-width="290px" offset-y attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left" v-model="filterModel.dateFrom"
                                                :placeholder="$t('shared.dateFrom')" readonly :clearable="true" ref="processingDateFromPicker"
                                                v-on="on" type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateFrom" no-title scrollable @change="search" @input="onDateChange('from')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="processingDateToMenu" :close-on-content-click="false" :nudge-right="10"
                                    transition="scale-transition" lazy full-width min-width="290px" offset-y attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left" v-model="filterModel.dateTo"
                                                :placeholder="$t('shared.dateTo')" readonly :clearable="true" ref="processingDateToPicker"
                                                v-on="on" type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateTo" no-title scrollable @change="search" @input="onDateChange('to')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <button @click="reset" class="btn btn-primary btn-action mt-1">
                                {{ $t('shared.reset') }}
                            </button>
                        </div>
                    </div>
                    <template>
                        <v-data-table :headers="headers" :items="ratingResults" :total-items="ratingResults.length"
                            :pagination.sync="pagination" @update:pagination="updatePaginate"
                            :rows-per-page-text="$t('shared.rowsPerPage')" :rows-per-page-items='[10, 25, 50, 100]'
                            item-key="requestId" class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">
                                        {{ props.item.providerName }}
                                    </td>
                                    <td class="text-center">
                                        {{ getServiceName(props.item.serviceType) }}
                                    </td>
                                    <td class="text-center">
                                        <span v-for="n in 5" :key="n" style="font-size: 20px;">
                                            <i :class="['fa-star', props.item.rating >= n ? 'fas' : 'far']"
                                                :style="{ color: props.item.rating >= n ? 'var(--color-4)' : 'var(--color-4)'}"></i>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        {{ formatDate(props.item.lastModifiedDate) }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.reason }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>